(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("rxjs"));
	else if(typeof define === 'function' && define.amd)
		define(["rxjs"], factory);
	else if(typeof exports === 'object')
		exports["gloperate"] = factory(require("rxjs"));
	else
		root["gloperate"] = factory(root["rxjs"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE_rxjs__) {
return 